import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';

import { CssBaseline, ThemeProvider } from '@mui/material';

import { AuthProvider } from 'services/auth/authContext';

import AppRoutes from 'AppRoutes';

import { HouseDataProvider } from 'utils/contexts/houseContext';

import reportWebVitals from './reportWebVitals';
// import App from './App';

import theme from './ThemeProvider/theme'; // Import your custom theme

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <HouseDataProvider>
          <AppRoutes />
        </HouseDataProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
